import { ePageBaseStatus } from "../../../../models/ePageBaseStatus";
import { IDgTuanKetQuaActionTypes } from "../../../action-types/danh-gia/tuan/IDgTuanKetQuaActionType";
import { IDgTuanReducer } from "../../../page-state-model/danh-gia/tuan/IDgTuanReducer";
const iniState: IDgTuanReducer = {
    filter: {
        dm_lop_id: 0,
        hoc_ky: 0,
        nam_hoc: "",
        thang: 0,
        sis_dgdk_dm_nlpc_id: 0,
        ts_hocsinh_id: 0,
        pl_tuan_id: 0,
        tuan_thu: 0

    },
    hocSinhs: [],
    ketQuas: [],
    soNhanXetItems: [],
    status: ePageBaseStatus.is_not_initialization
}
export const dgTuanKetQuaReducer = (state: IDgTuanReducer=iniState, action: IDgTuanKetQuaActionTypes): IDgTuanReducer => {
    switch (action.type) {
        case "DG_TUAN_CHANGE_FILER":
            return {
                ...state, filter: action.payload
            }
        case "DG_TUAN_HOC_SINH_LOAD_SUCCESS":
            return {
                ...state, hocSinhs: action.payload
            }
        case "DG_TUAN_KET_QUA_LOAD_SUCCESS":
            return {
                ...state, ketQuas: action.payload
            }
        case "DG_TUAN_SO_NHAN_XET_ITEM_LOAD_SUCCESS":
            return {
                ...state, soNhanXetItems: action.payload
            }
        case "DG_TUAN_SAVE_KETQUA_SUCCESS":
            return {
                ...state,
                ketQuas: [...state.ketQuas.filter(x => x.id !== action.payload.id), action.payload]
            }


        default:
            return state;
    }
}